import { createMutationStore } from '@ferreri/minato-react-utils';
import { postOccurrence } from './event.client';

export const useCreateOccurrence = () => {
  return createMutationStore({
    mutationFn: postOccurrence,
    retry: false,
  });
};
